"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
const index_1 = __importDefault(require("./click-outside/index"));
exports.useOnClickOutside = index_1.default;
exports.default = {};
